import React from 'react';
import PropTypes from 'prop-types';

export default class Sticky extends  React.Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.setInitialHeights = this.setInitialHeights.bind(this);
  }

  componentDidMount() {
    this.setInitialHeights();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  setInitialHeights() {
    const sticky = document.querySelector('[data-sticky]');
    sticky.setAttribute('data-sticky-initial', sticky.getBoundingClientRect().top);
  }

  handleScroll() {
    const className = this.props.className;
    const sticky = document.querySelector('[data-sticky]');
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    const bottom = document.documentElement.scrollHeight || document.body.scrollHeight;
    const stickyInitial = parseInt(sticky.getAttribute('data-sticky-initial'), 10);
    const stickyEnter = parseInt(sticky.getAttribute('data-sticky-enter'), 10) || stickyInitial;
    const stickyExit = parseInt(sticky.getAttribute('data-sticky-exit'), 10) || bottom;
    if (top >= stickyEnter && top <= stickyExit) {
      sticky.classList.add(className);
    } else {
      sticky.classList.remove(className);
    }
  }

  render() {
    const {enter, exit, children } = this.props;
    return (<div
      className={'Sticky'}
      data-sticky
      data-sticky-enter={enter}
      data-sticky-exit={exit}
        >
        {children}
        </div>);
  }
}

Sticky.propTypes = {
  className: PropTypes.string,
  enter: PropTypes.string,
  exit: PropTypes.string,
  children: PropTypes.node,
};
